import { http } from './http'
import { Pagination, PaginationParams } from './map'
import {
  ShippingBand,
  ShippingBandPayload,
  ShippingStatus,
} from '../../common/models/shipping-bands'

export const getShippings = (
  params?: PaginationParams & { packageReady?: boolean },
) => http.get<Pagination<ShippingBand>>(`/operations/shippings`, { params })

export const updateShipping = (id: string, data: ShippingBandPayload) =>
  http.put<ShippingBand>(`/operations/shippings/${id}`, data)

export const getShippingById = (id: string) =>
  http.get<ShippingBand>(`/operations/shippings/${id}`)

export const downloadAwb = (awbNumber: string) =>
  http.get(`/operations/shippings/awb/${awbNumber}/download`, {
    responseType: 'blob',
  })

export const shippingsStatus = () =>
  http.get<ShippingStatus[]>('/operations/shippings/status')

export const cancelShipping = (id: string) =>
  http.put(`/operations/shippings/${id}/cancel`)
